import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/stuLogin'
    },
    {
      path: '/stuLogin',
      name: 'stuLogin',
      meta: { hidden: false,title:"考生登录"},
      component: () => import('@/views/stuLogin.vue')
    },
    {
      path: '/adminLogin',
      name: 'adminLogin',
      meta: { hidden: false,title:"考场登录"},
      component: () => import('@/views/adminLogin.vue')
    },
    {
      path: '/notice',
      name: 'notice',
      component: () => import('@/views/notice.vue')
    },
    {
      path: '/noticeFromWork',
      name: 'noticeFromWork',
      component: () => import('@/views/noticeFromWork.vue')
    },
    {
      path: '/waitCheck',
      name:'waitCheck',
      component: () => import('@/views/waitingCheck.vue'),
      children: [
        {
          path:'wait',
          name: 'wait',
          props: { checkOk: false },
          component: () => import('@/views/waitingTest.vue')
        },
        {
          path: 'startExam:test_id',
          name: 'startExam',
          component: () => import('@/views/startExam.vue')
        }
      ]
    },
    // {
    //   path: '/wait',
    //   name: 'wait',
    //   component: () => import('@/views/waitingTest.vue')
    // },
    {
      path: '/endWork',
      name: 'endWork',
      component: () => import('@/views/endWork.vue')
    },
    // {
    //   path: '/startExam:test_id',
    //   name: 'startExam',
    //   component: () => import('@/views/startExam.vue')
    // },
    {
      path: '/workSearch',
      name: 'workSearch',
      component: () => import('@/views/workSearch.vue'),
      children: [
        {
          path: 'myWork',
          name: 'myWork',
          component: () => import('@/components/myWork.vue'),
          meta: {
            title: '我的考试'
          }
        },
        {
          path: 'workPlan',    // 登录
          name: 'workPlan',
          component: () => import('@/components/workPlan.vue'),
          meta: {
            title: '考试计划'
          }
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js